import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMultiOptions } from 'src/app/core/interfaces/onboarding/business-profile/business-multi-options.interface';

@Component({
  selector: 'app-kendo-checkbox-group',
  templateUrl: './kendo-checkbox-group.component.html',
  styleUrls: ['./kendo-checkbox-group.component.scss'],
})
export class KendoCheckboxGroupComponent implements OnInit {
  @Input() options: IMultiOptions[];
  @Input() clickEvent: () => Promise<unknown>;
  @Input() cssClass: 'grid' | 'stack' = 'stack';
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  selectedIndexList: number[] = [];

  ngOnInit(): void {
    const len = this.options.length;
    for (let i = 0; i < len; i += 1) {
      if (this.options[i].selected)
        this.selectedIndexList.push(this.options[i].id);
    }
  }

  async onClick(option: IMultiOptions) {
    if (this.clickEvent !== undefined) await this.clickEvent();
    this.outputParameter.emit(option);
  }
}
